// if (document.querySelector('.intro')) {
//     const buttons = document.querySelectorAll('.intro__switch details')
//     const markers = document.querySelectorAll('.intro__markers .marker')
//     buttons.forEach(button => {
//         button.addEventListener('click', () => {
//             if (button.getAttribute('data-open') == 0) {
//                 buttons.forEach(b => {
//                     b.setAttribute('data-open', 0)
//                 })
//                 button.setAttribute('data-open', 1)
//             } else {
//                 button.setAttribute('data-open', 0)
//             }
//             var flag = 0;
//             buttons.forEach(b => {
//                 if (b.getAttribute('data-open') == '1') {
//                     flag = 1
//                 }
//             });
//             if (flag) {
//                 markers.forEach(marker => {
//                     if (marker.getAttribute('data-term-id') == button.getAttribute('data-term-id')) {
//                         marker.classList.add('marker__visible')
//                     } else {
//                         marker.classList.remove('marker__visible')
//                     }

//                 });
//             } else {
//                 markers.forEach(marker => {
//                     marker.classList.add('marker__visible')
//                 })
//             }
//         })
//     });

// }
// if (document.querySelector('.intro')) {
//     const buttons = document.querySelectorAll('.intro__switch details')
//     const markers = document.querySelectorAll('.intro__markers .marker')
//     buttons.forEach(button => {
//         button.addEventListener('click', () => {
//             var id = button.getAttribute('data-term-id');
//             if (button.getAttribute('data-open') == 0) {
//                 buttons.forEach(b => {
//                         b.removeAttribute('open')
//                         b.setAttribute('data-open', 0)
//                 })
//                 button.setAttribute('data-open', 1)
//             } else {
//                 button.setAttribute('data-open', 0)
//                 buttons.forEach(b => {
//                     if (b.getAttribute('data-term-id') == 0) {
//                         b.setAttribute('open', 1)
//                         b.setAttribute('data-open', 1)
//                         id = 0;
//                     }
//                 })
//             }


//             if (id == 0) {
//                 markers.forEach(marker => {
//                     marker.classList.add('marker__visible')
//                 });
//             } else {

//                 markers.forEach(marker => {
//                     if (marker.getAttribute('data-term-id') == id) {
//                         marker.classList.add('marker__visible')
//                     } else {
//                         marker.classList.remove('marker__visible')
//                     }
//                 });
//             }
//         })
//     });
// }

